import React from "react";

function ViewContractIcon() {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g id="View contract">
          <path
            id="Subtract"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.6224 1.6224C4.02091 1.22388 4.56141 1 5.125 1H12.7966C13.327 1 13.8357 1.21071 14.2108 1.58579L19.4142 6.78921C19.7893 7.16429 20 7.67299 20 8.20343V14.2047C19.4024 14.0095 18.7686 13.8944 18.1111 13.8721V8.4375H12.5625V2.88889H5.88889C5.3366 2.88889 4.88889 3.3366 4.88889 3.88889V19.3611C4.88889 19.9134 5.3366 20.3611 5.88889 20.3611H12.8493C13.6516 21.2287 14.6747 21.8884 15.8295 22.25H5.125C4.56141 22.25 4.02091 22.0261 3.6224 21.6276C3.22388 21.2291 3 20.6886 3 20.125V3.125C3 2.56141 3.22388 2.02091 3.6224 1.6224ZM13.283 15.6389C12.6906 16.1756 12.1923 16.8145 11.8156 17.5278H7.25V15.6389H13.283ZM7.25 13.75V11.8611H15.75V13.75H7.25Z"
            fill="white"
          />
          <path
            id="Vector"
            d="M18.416 14.875C16.1433 14.875 14.2024 16.2886 13.416 18.2841C14.2024 20.2795 16.1433 21.6932 18.416 21.6932C20.6887 21.6932 22.6297 20.2795 23.416 18.2841C22.6297 16.2886 20.6887 14.875 18.416 14.875ZM18.416 20.5568C17.1615 20.5568 16.1433 19.5386 16.1433 18.2841C16.1433 17.0295 17.1615 16.0114 18.416 16.0114C19.6706 16.0114 20.6887 17.0295 20.6887 18.2841C20.6887 19.5386 19.6706 20.5568 18.416 20.5568ZM18.416 16.9205C17.6615 16.9205 17.0524 17.5295 17.0524 18.2841C17.0524 19.0386 17.6615 19.6477 18.416 19.6477C19.1706 19.6477 19.7797 19.0386 19.7797 18.2841C19.7797 17.5295 19.1706 16.9205 18.416 16.9205Z"
            fill="white"
          />
        </g>
      </svg>
    </div>
  );
}

export default ViewContractIcon;
